export default {"src":"/_next/static/media/OPEN.b0f81174.svg","height":18,"width":18};